import api from './api';

const coachService = {
  /**
   * 教練名冊（以證照庫為準）
   * @param {Object} params - { name, school, sport, has_cert }
   */
  listCoaches: async (params = {}) => {
    const response = await api.get('/coaches/list', { params });
    return response.data;
  },

  /**
   * 教練成效（帶隊選手成績，運動以證照庫專長為準）
   * @param {string} name - 教練姓名
   * @param {string} sport - 運動類別
   */
  getPerformance: async (name, sport, schools) => {
    const response = await api.get('/coaches/performance', {
      params: {
        name,
        sport,
        ...(schools && schools.length ? { schools: schools.join(',') } : {}),
      },
    });
    return response.data;
  },
};

export default coachService;
